import React, { lazy } from 'react';
import { Layout } from '../components/Layout';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { GoogleReviews } from '../components/GoogleReviews';
import { MapPin, MessageCircle, Mail, Calendar } from 'lucide-react';
import { useTranslation } from '../i18n';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
const MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1241.0181846982155!2d-0.104187760804084!3d51.53089276153758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760f7c6534e077%3A0xa54a590bd3b2a149!2sDentico%20Clinic%20-%20Private%20Dentist%20in%20Angel%2C%20Islington!5e0!3m2!1suk!2suk!4v1769722166469!5m2!1suk!2suk';
export function ContactPage() {
  const {
    t
  } = useTranslation();
  return <Layout data-id="element-170">
      <div className="bg-teal-900 py-20 text-white" data-id="element-171">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-172">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-173">
            {t('contact.title')}
          </h1>
          <p className="text-xl text-teal-100 max-w-2xl mx-auto" data-id="element-174">
            {t('contact.subtitle')}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-175">
        <div className="grid lg:grid-cols-3 gap-12" data-id="element-176">
          {/* Contact Info */}
          <div className="lg:col-span-1 space-y-8" data-id="element-177">
            <Card className="p-8" data-id="element-178">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-179">
                {t('contact.getInTouch')}
              </h2>

              <div className="space-y-6" data-id="element-180">
                <div className="flex items-start gap-4" data-id="element-181">
                  <div className="p-2 bg-teal-50 rounded-lg text-teal-600" data-id="element-182">
                    <MapPin className="w-6 h-6" data-id="element-183" />
                  </div>
                  <div data-id="element-184">
                    <h3 className="font-semibold text-gray-900 mb-1" data-id="element-185">
                      {t('contact.visitUs')}
                    </h3>
                    <p className="text-gray-600" data-id="element-186">
                      360-364 City Rd
                      <br data-id="element-187" />
                      London EC1V 2PY
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-188">
                  <div className="p-2 bg-teal-50 rounded-lg text-teal-600" data-id="element-189">
                    <MessageCircle className="w-6 h-6" data-id="element-190" />
                  </div>
                  <div data-id="element-191">
                    <h3 className="font-semibold text-gray-900 mb-1" data-id="element-192">
                      {t('contact.whatsapp')}
                    </h3>
                    <p className="text-gray-600 mb-2" data-id="element-193">
                      {t('contact.whatsappDesc')}
                    </p>
                    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-teal-600 font-medium hover:underline" data-id="element-194">
                      {t('contact.chatOnWhatsapp')}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-195">
                  <div className="p-2 bg-teal-50 rounded-lg text-teal-600" data-id="element-196">
                    <Mail className="w-6 h-6" data-id="element-197" />
                  </div>
                  <div data-id="element-198">
                    <h3 className="font-semibold text-gray-900 mb-1" data-id="element-199">
                      {t('contact.email')}
                    </h3>
                    <a href="mailto:infodenticodentalclinic@gmail.com" className="text-teal-600 hover:underline" data-id="element-200">
                      infodenticodentalclinic@gmail.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Book Online Button */}
              <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-201">
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-202">
                  <Button fullWidth size="lg" className="gap-2" data-id="element-203">
                    <Calendar className="w-5 h-5" data-id="element-204" />
                    {t('nav.bookOnline')}
                  </Button>
                </a>
              </div>
            </Card>

            <Card className="p-8" data-id="element-205">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-206">
                {t('contact.openingHours')}
              </h2>
              <div className="space-y-3" data-id="element-207">
                <div className="flex justify-between items-center pb-3 border-b border-gray-100" data-id="element-208">
                  <span className="text-gray-600" data-id="element-209">{t('footer.monFri')}</span>
                  <span className="font-medium text-gray-900" data-id="element-210">
                    10:00 - 18:00
                  </span>
                </div>
                <div className="flex justify-between items-center pb-3 border-b border-gray-100" data-id="element-211">
                  <span className="text-gray-600" data-id="element-212">{t('footer.saturday')}</span>
                  <span className="font-medium text-gray-900" data-id="element-213">
                    10:00 - 18:00
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-214">
                  <span className="text-gray-600" data-id="element-215">{t('footer.sunday')}</span>
                  <span className="font-medium text-red-500" data-id="element-216">
                    {t('footer.closed')}
                  </span>
                </div>
              </div>
            </Card>
          </div>

          {/* Map */}
          <div className="lg:col-span-2" data-id="element-217">
            <div className="bg-gray-100 rounded-2xl overflow-hidden h-full min-h-[500px] shadow-lg" data-id="element-218">
              <iframe src={MAPS_EMBED_URL} width="100%" height="100%" style={{
              border: 0,
              minHeight: '500px'
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Dentico Clinic Location" data-id="element-219"></iframe>
            </div>
          </div>
        </div>
      </div>

      <GoogleReviews data-id="element-220" />
    </Layout>;
}